// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3KanL","rightAdornment":"Header_rightAdornment__3Y2Ch"};